
















































































































import {
  Component, mapState, Watch, mixins, Vue,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {AuthorizationStore, UpdateinfoStore, Payload, CommonsStore} from '@samclick-store-factory';
import { _forEach, _includes} from '@samclick-lodash';
import { emailRegex } from '@/utils/common-utils';

class FormData {
    accountID: number | string = ''

    // ECOPAYZ
    number: string = ''

    // shared with Bankwire
    mail: string = ''

    fname: string = ''

    // Bankwire
    name: string = ''

    paymentCrypto: string = ''

    bankName: string = ''

    branchCode: string = ''

    bankAddress: string = ''

    swiftCode: string = ''

    abaNumber: string = ''

    iban: string = ''

    additionalInfo: string = ''

    accountHolderAddress: string = ''

    intermediary: string = ''

    bankRouting: string = ''

    bankPhone: string = ''

    address: string = ''
}

class UpdatePaymentTabState {
    public payment: number = 0

    public paymentThreshold: number = 0

    public minPaymentThreshold: number = 0

    public formDataEcoPayz: FormData = new FormData()

    public formDataBankWire: FormData = new FormData()

    public formDataOther: FormData = new FormData()

    public formDataNeteller: FormData = new FormData()

    public formDataSkrill: FormData = new FormData()

    public paymentCrypto: string = ''

    public address: string = ''
}

@Component({
  /**
   * Imported components
   * */
  components: {
    ...mapState({
      currentPaymentAccounts: (state: any) => state.updateinfo.updateinfoStore.currentPaymentAccount,
    }),
  },
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      currentPaymentAccount: (state: any) => state.updateinfo.updateinfoStore.currentPaymentAccount,
      accountTypesCrypto: (state: any) => state.commons.commonsStore.accountTypesCrypto,
      paymentAccountTypes: (state: any) => state.commons.commonsStore.paymentAccountTypes,
    }),

      filteredPaymentAccountTypes() {
          var userRegions = this.userSubscription;
          return this.paymentAccountTypes.filter(function (account) {
              if (!account.allowedRegions || account.allowedRegions.length === 0) {
                  return true;
              }
              return account.allowedRegions.some(function (region) {
                  return userRegions.includes(region);
              });
          });
      },
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class UpdatePaymentTab extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new UpdatePaymentTabState();

    hasUserEditedThreshold = false

    rules = {}

    userSubscription = []


  /**
   * Watchers
   * */
  @Watch('state.payment')
  paymentWatcher(newVal: number, oldVal: number) {
    this.changeMinPaymentThreshold();
  }

  @Watch('ifLocaleChange', { immediate: true })
  localeChanges() {
    this.rules = {
      number: [
        { required: true, message: this.$t('signup.err_account_number'), trigger: 'blur' },
      ],
      payment: [
        { required: true, message: this.$t('signup.err_payment_type'), trigger: 'blur' },
      ],
      paymentCrypto: [
        { required: true, message: this.$t('forms.pay_acct_crypto'), trigger: 'change' },
      ],
      mail: [
        { required: true, message: this.$t('signup.err_email_reg'), trigger: 'blur' },
        { min: 4, message: this.$t('signup.err_email_reg_min'), trigger: 'blur' },
        {
          type: 'email', pattern: this.commonUtil.emailRegex(), message: this.$t('signup.err_email_reg_invalid'), trigger: ['blur', 'change'],
        },
      ],
      fname: [
        { required: true, message: this.$t('signup.err_reg_name'), trigger: 'blur' },
      ],
      name: [
        { required: true, message: this.$t('signup.err_account_holder'), trigger: 'blur' },
      ],
      bankName: [
        { required: true, message: this.$t('signup.err_bank_name'), trigger: 'blur' },
      ],
      branchCode: [
        { required: true, message: this.$t('signup.err_branch_code'), trigger: 'blur' },
      ],
      bankAddress: [
        { required: true, message: this.$t('signup.err_branch_add'), trigger: 'blur' },
      ],
      accountHolderAddress: [
        { required: true, message: this.$t('signup.err_acct_holder_add'), trigger: 'blur' },
      ],
      swiftCode: [
        { required: true, message: this.$t('signup.err_swift_code'), trigger: 'blur' },
      ],
      address: [
        { required: true, message: this.$t('signup.err_address'), trigger: 'blur' },
      ],
    };
  }

    /**
   * Methods
   * */
    populateForms(response: object) {
      const formName = this.getFormName(response.type_id);
      if (this.getFormName(response.type_id)) {
        this.state[formName].accountID = response.id;
        this.state[formName].name = response.name || '';
        if (response.type_id === 10) {
          this.state[formName].paymentCrypto = response.name || '';
          this.state[formName].address = response.number || '';
        }
        this.state[formName].bankName = response.bank_name || '';
        this.state[formName].bankPhone = response.bank_phone || '';
        this.state[formName].branchCode = response.branch_code || '';
        this.state[formName].bankAddress = response.bank_address || '';
        this.state[formName].intermediary = response.bank_intermediary || '';
        this.state[formName].bankRouting = response.bank_routing || '';
        this.state[formName].swiftCode = response.swift_code || '';
        this.state[formName].abaNumber = response.aba_number || '';
        this.state[formName].iban = response.iban || '';
        this.state[formName].additionalInfo = response.additional_info || '';
        this.state[formName].accountHolderAddress = response.account_holder_address || '';
        // Ecopayz
        this.state[formName].number = response.number || '';
        this.state[formName].mail = response.mail || '';
        this.state[formName].fname = response.fname || '';
      }
    }

    getPaymentAccount() {
      UpdateinfoStore.getCurrentPaymentAccount().then((responseData: object) => {
        const response = responseData.data.main_account;
        this.state.payment = response.type_id;

        // Assign main
        this.populateForms(response);

        // Assign Subs
        this.assignSubs(responseData.data);
      });
    }

    assignSubs(response: object) {
      const prevAccounts = response.prev_accounts;
      if (prevAccounts) {
        _forEach(prevAccounts, (prevAccount) => {
          this.populateForms(prevAccount);
        });
      }
    }

    submit() {

      if (this.state.payment <= 0) {
        this.showAlert(this.$t('signup.err_payment_type').toString(), this.$data.SamclickAlert.ERROR);

        return false;
      }

      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          const thresholdNum = Number(this.state.paymentThreshold);
          const sanitizedThreshold = Number.isNaN(thresholdNum) ? this.state.minPaymentThreshold : thresholdNum;
          this.state.paymentThreshold = Math.max(this.state.minPaymentThreshold, sanitizedThreshold);
          this.showAlert(this.$t('api_error.prompt_saving').toString(), this.$data.SamclickAlert.WARNING, true).then(() => {
            const formName = this.getFormName(this.state.payment);
            const payload = {
              id: this.state[formName].accountID || 0,
              type_id: this.state.payment,
              affiliate_id: AuthorizationStore.currentLoggedUserInState.id,
            };

            if (this.state.payment === 2) {
              payload.number = this.state[formName].number;
              payload.mail = this.state[formName].mail;
              payload.fname = this.state[formName].fname;
            } else if (this.state.payment === 5) {
              payload.number = this.state[formName].number;
              payload.name = this.state[formName].name;
              payload.bank_name = this.state[formName].bankName;
              payload.bank_phone = this.state[formName].bankPhone;
              payload.branch_code = this.state[formName].branchCode;
              payload.bank_address = this.state[formName].bankAddress;
              payload.bank_intermediary = this.state[formName].intermediary;
              payload.bank_routing = this.state[formName].bankRouting;
              payload.swift_code = this.state[formName].swiftCode;
              payload.aba_number = this.state[formName].abaNumber;
              payload.iban = this.state[formName].iban;
              payload.additional_info = this.state[formName].additionalInfo;
              payload.account_holder_address = this.state[formName].accountHolderAddress;
            } else if (this.state.payment === 10) {
                payload.number = this.state[formName].address;
                payload.name = this.state[formName].paymentCrypto;
            }  else if (this.state.payment === 3) {
                payload.number = this.state[formName].number;
                payload.mail = this.state[formName].mail;
            }  else if (this.state.payment === 11) {
                payload.mail = this.state[formName].mail;
            }

            const errorPaymentThreshold = (error: any) => {
              if (error && error.data && error.data.code === 'invalid_email') {
                this.showAlert(this.$t('api_error.invalid_email').toString(), this.$data.SamclickAlert.ERROR);
              } else {
                this.showAlert(this.$t('api_error.prompt_unknown_err').toString(), this.$data.SamclickAlert.ERROR);
              }
            }

            UpdateinfoStore.updatePaymentAccount(new Payload(payload)).then(() => {
              UpdateinfoStore.updatePaymentThreshold(new Payload({
                id: AuthorizationStore.currentLoggedUserInState.id,
                payment_threshold: this.state.paymentThreshold,
              })).then(() => {
                this.showSuccessAlert();
                this.getPaymentAccount();
                AuthorizationStore.getMyDetails();
              }).catch((error) => {
                errorPaymentThreshold(error);
              });
            }).catch((error) => {
              errorPaymentThreshold(error);
            });
          }).catch(() => {});
        }
      });

      return true;
    }

    getFormName(typeID: number) {
      switch (typeID) {
        case 2: {
          return 'formDataEcoPayz';
        }
        case 3: {
            return 'formDataNeteller';
        }
        case 5: {
          return 'formDataBankWire';
        }
        case 10: {
            return 'formDataOther';
        }
        case 11: {
            return 'formDataSkrill';
        }
        default: {
          return '';
        }
      }
    }

    /**
   * Computed
   * */
    get formData() {
        if (this.state.payment === 2) {
            return this.state.formDataEcoPayz
        }else if (this.state.payment === 5) {
            return this.state.formDataBankWire;
        }else if (this.state.payment === 10) {
            return this.state.formDataOther
        }else if (this.state.payment === 3) {
            return this.state.formDataNeteller
        }else if (this.state.payment === 11) {
            return this.state.formDataSkrill
        }
    }

    changeMinPaymentThreshold() {
      const currentData = this.clone(AuthorizationStore.currentLoggedUserInState);
      if (this.state.payment === 10) {
        this.state.minPaymentThreshold = 1000;
      } else {
        this.state.minPaymentThreshold = currentData.min_payment_threshold;
      }

      const thresholdNumeric = this.state.paymentThreshold;
      if (!this.hasUserEditedThreshold || Number.isNaN(thresholdNumeric) || thresholdNumeric < this.state.minPaymentThreshold) {
        this.changeThreshold(currentData);
      }
    }

    changeThreshold(currentData: { payment_threshold: any }) {
      const userThreshold = Number(currentData.payment_threshold) || 0;
      const hasValidThreshold = !Number.isNaN(userThreshold);

      if (hasValidThreshold && userThreshold >= this.state.minPaymentThreshold) {
        this.state.paymentThreshold = userThreshold;
      } else {
        this.state.paymentThreshold = this.state.minPaymentThreshold;
      }
      this.hasUserEditedThreshold = false;
    }

    onThresholdInput(value: number) {
      if (!Number.isNaN(value)) {
        this.state.paymentThreshold = value;
        this.hasUserEditedThreshold = true;
      }
    }

    async loadUserSubscription() {
        const response = await CommonsStore.getAffiliateSubscription();
        this.userSubscription = response.data;
    }

    /**
   * Lifecycle hooks
   * */
    created() {
      this.getPaymentAccount();
      const currentData = this.clone(AuthorizationStore.currentLoggedUserInState);
      this.state.minPaymentThreshold = currentData.min_payment_threshold;
      this.changeThreshold(currentData);
    }

    async mounted() {
        await this.loadUserSubscription();
    }

    beforeUpdate() {}

    beforeCreate() {
      this.commonUtil = {
        emailRegex,
      };
    }
}
